import { render, staticRenderFns } from "./DocTemplateZonesContext.vue?vue&type=template&id=3b866a9f&"
import script from "./DocTemplateZonesContext.vue?vue&type=script&lang=js&"
export * from "./DocTemplateZonesContext.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports